(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-logo-carousel"] && !Shopify.designMode) return;
  try {
    
  class BrandLogoCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.viewport = this.querySelector('.blc__viewport');
      this.rail = this.querySelector('[data-blc-rail]');
      this.sourceGroup = this.querySelector('[data-blc-group]');
      this.toggle = this.querySelector('[data-blc-toggle]');
      this.toggleLabel = this.querySelector('[data-blc-toggle-label]');
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.originalItems = Array.from(this.sourceGroup?.children || []).map((item) => item.cloneNode(true));
      this.lastWidth = 0;

      this.handleToggle = () => {
        this.dataset.paused = this.dataset.paused === 'true' ? 'false' : 'true';
        this.syncToggle();
      };

      this.handleMotionChange = () => {
        this.lastWidth = 0;
        this.render();
      };

      this.toggle?.addEventListener('click', this.handleToggle);
      this.motionPreference.addEventListener('change', this.handleMotionChange);

      this.resizeObserver = new ResizeObserver(() => {
        const width = Math.round(this.viewport?.clientWidth || 0);
        if (width === this.lastWidth) return;

        this.lastWidth = width;
        window.requestAnimationFrame(() => this.render());
      });

      if (this.viewport) this.resizeObserver.observe(this.viewport);

      this.render();
      this.syncToggle();
      this.classList.add('is-ready');
    }

    disconnectedCallback() {
      this.toggle?.removeEventListener('click', this.handleToggle);
      this.motionPreference?.removeEventListener('change', this.handleMotionChange);
      this.resizeObserver?.disconnect();
    }

    createItem(item, hidden) {
      const clone = item.cloneNode(true);

      if (hidden) {
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        clone.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
          element.setAttribute('tabindex', '-1');
        });
        clone.querySelectorAll('img').forEach((image) => image.setAttribute('alt', ''));
      }

      return clone;
    }

    createGroup(hidden = false) {
      const group = document.createElement('ul');
      group.className = 'blc__group';
      group.setAttribute('role', 'list');

      if (hidden) group.setAttribute('aria-hidden', 'true');

      this.originalItems.forEach((item) => group.append(this.createItem(item, hidden)));
      return group;
    }

    render() {
      if (!this.viewport || !this.rail || this.originalItems.length === 0) return;

      this.rail.replaceChildren();
      const primary = this.createGroup(false);
      this.rail.append(primary);
      this.dataset.hasDuplicate = 'false';

      if (this.motionPreference.matches) return;

      const targetWidth = this.viewport.clientWidth + Number.parseFloat(getComputedStyle(this).getPropertyValue('--blc-slide-width'));

      while (primary.scrollWidth < targetWidth) {
        this.originalItems.forEach((item) => primary.append(this.createItem(item, true)));
      }

      const duplicate = primary.cloneNode(true);
      duplicate.setAttribute('aria-hidden', 'true');
      duplicate.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
        element.setAttribute('tabindex', '-1');
      });
      duplicate.querySelectorAll('img').forEach((image) => image.setAttribute('alt', ''));
      this.rail.append(duplicate);
      this.dataset.hasDuplicate = 'true';
    }

    syncToggle() {
      if (!this.toggle || !this.toggleLabel) return;

      const paused = this.dataset.paused === 'true';
      const label = paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel;
      this.toggle.setAttribute('aria-pressed', String(paused));
      this.toggle.setAttribute('aria-label', label);
      this.toggleLabel.textContent = label;
    }
  }

  if (!customElements.get('brand-logo-carousel')) {
    customElements.define('brand-logo-carousel', BrandLogoCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
